import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const social = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 20,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
        users: [],
        comments: [],
        commentUsers: [],
        postLikes: [],
        commentLikes: [],
        likeUsers: [],
    }),
    mutations: {
        setSocials(state, payload) {
            state.items = payload.items;
            state.users = payload.users;
            state.filter.total = payload.total;
        },
        setSelectedSocials(state, payload) {
            state.selectedItems = payload;
        },
        setSocialPage(state, payload) {
            state.filter.page = payload;
            this.dispatch("getSocials");
        },
        setSocialTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch("getSocials");
        },
    },
    actions: {
        async getComments(store, payload) {
            await axios
                .post("post/loadcomments", {
                    id: payload,
                })
                .then((res) => {
                    /* store.state.comments = res.data.data.items.map((k) => {
                      return {
                        ...k,
                        subComments: [],
                      };
                    }); */
                    store.state.comments = res.data.data.items.sort((a, b) => {
                        return new Date(a.createDate) - new Date(b.createDate);
                    });
                    store.state.commentUsers = res.data.data.users;
                });
        },
        async getPostLikes(store, payload) {
            await axios
                .post("post/likes", {
                    id: payload,
                })
                .then((res) => {
                    store.state.postLikes = res.data.data.participants;
                    store.state.likeUsers = res.data.data.users;
                });
        },
        async getCommentLikes(store, payload) {
            await axios
                .post("post/commentLikes", {
                    id: payload,
                })
                .then((res) => {
                    store.state.commentLikes = res.data.data.participants;
                    store.state.likeUsers = res.data.data.users;
                });
        },
        async getSubComments(store, payload) {
            await axios
                .post("post/loadcomments", {
                    id: payload.id,
                    parentID: store.state.comments[payload.index].id,
                })
                .then((res) => {
                    store.state.comments[
                        payload.index
                    ].subComments = res.data.data.items.map((k) => {
                        return {
                            ...k,
                        };
                    });
                    store.state.commentUsers = [
                        store.state.commentUsers,
                        ...res.data.data.users,
                    ];
                });
        },
        async getSocials(store) {
            store.state.loading = true;
            await axios
                .post("post/load", {
                    ...store.state.filter,
                    skip: (store.state.filter.page - 1) * store.state.filter.take,
                })
                .then((res) => {
                    store.state.loading = false;
                    return store.commit("setSocials", res.data.data);
                });
        },
        async toggleSocial(store, payload) {
            var res = await axios.post("post/toggleisactive", {
                id: store.state.items[payload.index].id,
            });
            return res.data;
        },
        async deletePost(store, payload) {
            await axios
                .post("post/delete", {
                    id: store.state.items[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.items.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);
                        if (store.state.items.length == 0 && store.state.filter.page != 1) {
                            this.commit("setSocialPage", store.state.filter.page - 1);
                        }
                        store.state.filter.total = store.state.filter.total - 1;
                    }
                });
        },
        async deleteComment(store, payload) {
            await axios
                .post("post/deletecomment", {
                    id: store.state.comments[payload.index].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.comments.splice(payload.index, 1);
                        payload.context.$message.success(res.data.alert.message);
                    }
                });
        },
        async deleteSubComment(store, payload) {
            await axios
                .post("post/deletecomment", {
                    id: store.state.comments[payload.index].subComments[
                        payload.subCommentIndex
                    ].id,
                })
                .then((res) => {
                    if (res.data.alert.hasError) {
                        payload.context.$message.error(res.data.alert.message);
                    } else {
                        store.state.comments[payload.index].subComments.splice(
                            payload.subCommentIndex,
                            1
                        );
                        payload.context.$message.success(res.data.alert.message);
                    }
                });
        },
    },
    getters: {},
};
export default social;


// WEBPACK FOOTER //
// ./src/store/social.js